module.exports = __webpack_public_path__ + "static/EverForward6-ed9cf0682249a33e1815f8ea7f27f732.webp";